import passwordModalModule from "../passwordModalModule"
import expiredPasswordWarningModal from "./expiredPasswordWarningModal.html"

passwordModalModule.service("expiredPasswordWarningModal", [
    "$modal",
    function ($modal) {
        return function (remainingDays, changePasswordModal, credentials) {
            return $modal.open({
                template: expiredPasswordWarningModal,
                size: "m",
                backdrop: "static",
                controller: [ "$scope",
                    function ($scope) {
                        $scope.remainingDays = remainingDays
                        $scope.keyBundle = "authentication.expired.password.modal.warning"

                        $scope.openChangePasswordModal = function () {
                            $scope.$close()
                            return changePasswordModal(credentials, true)
                        }
                    }]
            })
        }
    }
])